import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthenticated, checkAuth } = useAuth();
  const location = useLocation();
  
  // If user data was passed from OAuth callback, trust it
  const hasUserFromState = location.state?.user || location.state?.fromOAuth;
  const shouldSkipCheck = hasUserFromState || isAuthenticated;
  const [isChecking, setIsChecking] = useState(!shouldSkipCheck);
  const hasChecked = useRef(false);

  useEffect(() => {
    if (shouldSkipCheck || hasChecked.current) return;
    
    hasChecked.current = true;
    checkAuth().finally(() => setIsChecking(false));
  }, [shouldSkipCheck, checkAuth]);

  // Show loading while checking auth
  if (loading || (isChecking && !shouldSkipCheck)) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" />
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated && !user && !hasUserFromState) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
